import { IAdpRecipientFromChain, ICluster, IPositionCoordinator, IContact } from '@nkr/models/index';
import JoditEditor from '@nkr/components/editor';
import config from '@nkr/views/ticketing/jodit-editor-config';
import Swaps from '../common/swaps';
import Coordinators from '../common/coordinators';
import SwapManager from '../common/swap-manager';
import AdpRecipientsFromChain from '../common/adp-recipients-from-chain';
import ReactHtmlParser from 'react-html-parser';

interface IProps {
    message: string,
    force: boolean,
    extra: string[],
    notes: string[],
    swaps: ICluster[],
    adpRecipientsFromChain: IAdpRecipientFromChain[],
    coordinators: IPositionCoordinator[],
    swapManager: IContact,
    deadlineDate: string,
    deadlineTime: string,
    includePreselectStatus: boolean,
    sidebar: boolean,
    onMessageChange: (message: string) => void
}

const MatchOffer = (props: IProps) => {
    const handleMessageChange = (message: string) => {
        props.onMessageChange(message);
    };

    const joditConfig = { ...config, height: '300px' };

    const hasClc = props.swaps.filter(x => x.positions.filter(p => p.hasClc).length > 0).length > 0;
    let centerId = props.swaps[0].positions[0].recipient.centerId;

    return (
        <>
            <div style={{ marginBottom: 20 }}>
                To accept or decline this match offer, <a href={__ADMIN__ + '/center/' + centerId + '/action-center/pending-swaps'}>click here</a>.
                {props.force && 
                    " Please reach out to <a href='mailto:NKRLogistics@kidneyregistry.com'>NKR Logistics</a> if you have any questions."
                };
            </div>

            {
                props.force ? (
                    <div style={{ marginBottom: 20 }}>
                        If you cannot accommodate the target surgery dates, please decline this offer.
                    </div>
                ) : (
                    <div style={{ marginBottom: 20 }}>
                        If you cannot accommodate the target surgery dates, please email{' '}
                        <a href='mailto:nkrlogistics@kidneyregistry.com'>
                            nkrlogistics@kidneyregistry.org
                        </a>{' '}
                        with a target surgery date that works for your center.
                    </div>
                )
            }


            {props.extra.map(extraLine =>
                <p>
                    {extraLine}
                </p>
            )}

            {hasClc && (
                <div style={{ marginBottom: 20 }}>
                    {props.swaps.map(swap =>
                        <>
                            {swap.positions.map(p =>
                                <div key={'clc-' + p.positionNumber}>
                                    The match in position {p.positionNumber} was driven by {p.recipient.center.alias}'s CLC score.
                                </div>
                            )}
                        </>
                    )}
                </div>
            )}

            <JoditEditor
                value={props.message}
                config={joditConfig}
                onChange={handleMessageChange}
                onBlur={() => null}
            />
            <br />

            <div style={{ marginBottom: 20 }}>Match Offer Deadline: <span style={{ color: 'red' }}>{props.deadlineTime}</span> ET on <span style={{ color: 'red' }}>{props.deadlineDate}</span></div>

            {props.notes.length > 0 && (
                <div style={{ marginBottom: 20 }}>
                    <div style={{ marginBottom: 10 }}>Please note:</div>
                    <ul>
                        {props.notes.map((note, index) =>
                            <li key={'note-' + index} style={{ listStyleType: 'disc' }}>{ReactHtmlParser(note)}</li>
                        )}
                    </ul>
                </div>
            )}

            <div style={{ marginBottom: 20 }}>
                If your center accepts this match, your center is agreeing to abide by the current <a href='https://www.kidneyregistry.com/membership-terms-legacy'>member center terms &amp; conditions</a>.
            </div>

            <div style={{ marginBottom: 5 }}><strong>Match Offer</strong></div>

            <Swaps
                includePreselectStatus={props.includePreselectStatus}
                swaps={props.swaps}
                sidebar={props.sidebar}
            />

            <div style={{ marginBottom: 5 }}><strong>Match Offer Coordinator Contact Information</strong></div>

            <Coordinators
                coordinators={props.coordinators}
                sidebar={props.sidebar}
            />

            {props.adpRecipientsFromChain.length > 0 && (
                <>
                    <div style={{ marginBottom: 5 }}><strong>Additional Transplants Retroactively Facilitated by this Swap's Chain Starter</strong></div>

                    <AdpRecipientsFromChain
                        list={props.adpRecipientsFromChain}
                        sidebar={props.sidebar}
                    />
                </>
            )}

            <div style={{ marginBottom: 5 }}><strong>Swap Manager</strong></div>

            <SwapManager data={props.swapManager} sidebar={props.sidebar} />
        </>
    );
}

export default MatchOffer;